export default __webpack_public_path__ + "static/media/icon-SweepsBox.0d042f00.svg";